import * as angular from "angular";

angular
  .module('bringoz.admin.routes', [
    'bringoz.admin.commons'
  ]);
